import { render, staticRenderFns } from "./PosCommon.vue?vue&type=template&id=05f3feac&"
import script from "./PosCommon.vue?vue&type=script&lang=js&"
export * from "./PosCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports